import { useEffect } from "react";
import { Button } from "@/components/ui/button";
import { Rocket, TrendingUp } from "lucide-react";

import { useMediaQuery } from "@/hooks/use-media-query";

import { Separator } from "@/components/ui/separator";
import { cn } from "@/lib/utils";

import { Testimonials } from "../components/testimonials";
import { WhyCarriapp } from "../components/why-carriapp";
import { HowToStart } from "../components/how-to-start";

import { Link, useNavigate } from "react-router-dom";
import SimpleHeader from "../components/simple-header";
import posthog from "posthog-js";
import { motion, useReducedMotion } from "framer-motion";



export const LandingPage = () => {
    const navigate = useNavigate();
    const isDesktop = useMediaQuery("(min-width: 1024px)");
    const isVisitor = localStorage.getItem("visitor");
    const reduceMotion = useReducedMotion();

    useEffect(() => {
        if (isVisitor) {
            navigate("/store");
        }
    }, [isVisitor, navigate]);



    return (
    (isVisitor)?(
        <></>
    ):
    <>
    <SimpleHeader/>
    <main className="noto-sans-regular mb-16 overflow-x-clip">
        <div className={cn("flex flex-col relative isolate w-full bg-[#FEEDE1] ",
            {
                "py-14 px-12 gap-8":isDesktop,
                "pt-8 px-4 pb-5":!isDesktop
            })}>
            {/* Hero: centered single-column (stats → h1 → subcopy → CTA) */}
            <div className="flex flex-row flex-wrap items-center justify-center gap-2 sm:gap-4">
                <div className="flex flex-col items-center text-[11px] sm:text-sm">
                    <span className="text-base sm:text-xl font-bold font-mono">+20%</span>
                    Ahorro Promedio
                </div>
                <Separator orientation="vertical" className="bg-foreground/20 mx-2 sm:mx-4" />
                <div className="flex flex-col items-center text-[11px] sm:text-sm">
                    <span className="text-base sm:text-xl font-bold font-mono flex gap-2">+18.000 <TrendingUp className="w-3 sm:w-4 text-muted-foreground"/></span>
                    usuarios están ahorrando
                </div>
            </div>

            <h1 className="text-3xl xl:text-5xl font-extrabold text-center mt-8 lg:mt-12">
                <span className="block">¿Gastas mucho en el súper?</span>
                <span className="block">
                    Con <span className="russo-one-regular text-[#3E7B54]">Carriapp</span>, ahorra tiempo y plata.
                </span>
            </h1>

            <p className="text-base font-semibold text-center max-w-2xl mx-auto mt-4">
                Arma tu lista y te decimos si conviene comprar todo en una tienda o combinar varias. Nosotros <span className="text-primary font-bold">armamos tu carrito</span>, considerando membresías y despacho, <span className="text-primary font-bold">para que el ahorro sea de verdad</span>.
            </p>

            <div className="flex justify-center mt-6">
                <Link to="/onboarding">
                    <Button onClick={() => posthog.capture("onboarding_cta_click")} className="h-16 text-xl font-semibold" variant="default" size={"lg"}>
                        <Rocket  className="!w-8 !h-8"/> ¡Comienza a ahorrar!</Button>
                </Link>
            </div>

             <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 1440 220"
                preserveAspectRatio="xMidYMid meet"
                aria-hidden="true"
                focusable="false"
                className="absolute bottom-0 left-0 w-full aspect-[1440/220] z-[-1] pointer-events-none"
            >
                <path
                    fill="#FFFFFF"
                    d="M 0,170 C 380,215 740,200 940,130 C 1140,55 1290,40 1440,60 L 1440,220 L 0,220 Z"
                />
            </svg>
        </div>
        {/* Image + stores: relocated out of the hero, placed below it */}
        <div className="flex flex-col w-full 2xl:w-[80%] mx-auto px-4 gap-8">
            <motion.div
                className="flex justify-center relative z-10 -mt-0 lg:-mt-12"
                initial={reduceMotion ? false : { opacity: 0, y: 16 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.7, ease: [0.4, 0, 0.2, 1] }}
            >
                <img
                    src="https://storage.googleapis.com/carry_images/web/mobile-landing.webp"
                    alt="Ilustración principal de Carriapp"
                    className="w-full max-w-2xl mx-auto h-auto"
                    width="1200"
                    height="900"
                    loading="lazy"
                    decoding="async"
                />
            </motion.div>
        </div>
        <div className="flex flex-col w-full 2xl:w-[80%] mx-auto px-4 mt-8  gap-4">
            <WhyCarriapp />
            <HowToStart />
            <Separator className="my-4" />
            <div className="flex flex-col items-center gap-3">
                <p className={cn("font-semibold",{
                    "text-center":!isDesktop,
                })}>Respaldado por: </p>
                <div className={cn("flex flex-row items-center gap-2 h-10 flex-wrap")}>
                    <a href="https://startupchile.org/blog/estas-son-las-startups-seleccionadas-para-big-10/" target="_blank" rel="noopener noreferrer"><img className={cn(isDesktop?"h-8":"h-5")} width="160" height="32" src="https://storage.googleapis.com/carry_images/StartUpChile_Color.png" alt="StartUp Chile"/></a>
                    <Separator orientation="vertical" className="bg-foreground/20 mx-4" />
                    <img className={cn(isDesktop?"h-8":"h-5")} width="160" height="32" src="https://storage.googleapis.com/carry_images/Google_for_Startups_logo.svg.png" alt="Google for Startups"/>
                </div>
            </div>
            <Separator className="my-4" />
            <h2 className={cn("font-semibold text-primary",{"text-2xl text-center":isDesktop," text-lg":!isDesktop})}
                >Lo que dicen nuestros usuarios</h2>
            <Testimonials />
        </div>
    </main>
    </>);
}

